import { Controller } from '@hotwired/stimulus';
import $ from 'jquery';

const MARK_CALLED_RELOAD_DELAY = 3000;

/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static values = {
        chatId: String,
        category: String,
        action: String,
        delayReload: Boolean,
    };

    async markCalled() {
        showPreloader();
        const urlMarkCalled = routes['app_messages_markcalled'].replace('__id__', this.chatIdValue);

        $.post(urlMarkCalled, {}, function() {
        }).fail(function() {
        });

        const urlAcceptCase = routes['app_messages_acceptcase']
            .replace('__id__', this.chatIdValue);

        if (this.delayReloadValue) {
            await new Promise(resolve => setTimeout(resolve, MARK_CALLED_RELOAD_DELAY));
        }

        await $.get(urlAcceptCase, response => {
            if (response.status) {
                reloadChatAndUserInformation();
            } else {
                if (response.message !== 'Case already accepted') {
                    addAlert('danger', response.message || translations['profile.An unknown error occurred.']);
                }
            }
        }).fail(() => {
            addAlert('danger', translations['profile.An unknown error occurred.']);
        });

        hidePreloader();

        dataLayer.push({
            'event': 'dataLayer.gaEvent',
            'gaEvent': {
                'category': this.categoryValue,
                'action': this.actionValue,
                'label': GA_EVENT_LABEL,
            },
        });
    }
}
